import React from 'react';
import { Check, Sparkles, ArrowUpRight } from 'lucide-react';
import { investmentPackages } from '../mock';
import { useAuth } from '../context/AuthContext';

const Packages = ({ onOpenPortal, onSelectPackage }) => {
  const { user } = useAuth();

  const handleSelect = (p) => {
    if (!user) {
      onOpenPortal?.();
      return;
    }
    onSelectPackage?.(p.deckId);
  };

  return (
    <section id="packages" className="px-4 md:px-10 py-20">
      <div className="mx-auto max-w-[1240px]">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-700/30 bg-emerald-100 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-800">
            <Sparkles size={13} className="text-emerald-600" /> Investment Packages
          </div>
          <h2 className="mt-4 font-serif text-emerald-950 text-4xl md:text-5xl leading-[1.05] tracking-tight">
            Choose the <span className="italic text-emerald-600">stake</span> that fits your journey.
          </h2>
          <p className="mt-4 text-emerald-900/70 text-[15px]">Certificate-backed, dividend-yielding, fully transferable membership packages.</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {investmentPackages.map((p) => (
            <div
              key={p.id}
              data-testid={`landing-package-${p.id}`}
              className={`relative rounded-2xl border p-7 flex flex-col ${p.popular ? 'border-emerald-500/60 bg-gradient-to-b from-[#0e2c1d] to-[#071710] green-glow' : 'border-emerald-900/60 bg-gradient-to-b from-[#0a1e14] to-[#061810]'}`}
            >
              {p.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-emerald-500 text-emerald-950 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest">
                  Most Popular
                </div>
              )}
              <div className="text-emerald-300 text-sm font-medium">{p.name}</div>
              <div className="mt-3 flex items-baseline gap-1">
                <span className="font-serif text-white text-5xl tracking-tight">${p.price.toLocaleString()}</span>
              </div>

              {/* Shares + Monthly highlight strip */}
              <div className="mt-4 grid grid-cols-2 rounded-xl border border-emerald-800/60 bg-[#04160d]/70 overflow-hidden">
                <div className="p-3 border-r border-emerald-800/60">
                  <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-emerald-300/80">Share Units</div>
                  <div className="mt-0.5 font-serif text-white text-lg">{p.shares.toLocaleString()}</div>
                </div>
                <div className="p-3">
                  <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-emerald-300/80">Monthly</div>
                  <div className="mt-0.5 font-serif text-emerald-300 text-lg">${p.monthly}<span className="text-emerald-100/60 text-xs"> × {p.months}m</span></div>
                </div>
              </div>

              <ul className="mt-5 space-y-2.5 text-[14px] text-emerald-100/85 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2">
                    <Check size={16} className="mt-0.5 text-emerald-400 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                data-testid={`landing-package-select-${p.id}`}
                onClick={() => handleSelect(p)}
                className={`mt-7 inline-flex items-center justify-center gap-1.5 rounded-full py-3 font-medium transition ${p.popular ? 'bg-emerald-500 hover:bg-emerald-400 text-emerald-950' : 'bg-emerald-900/50 hover:bg-emerald-800/60 text-emerald-50 border border-emerald-800/60'}`}
              >
                Select {p.name} <ArrowUpRight size={15} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Packages;
